
import React, { useState } from 'react';
import { ConfigCard } from './ConfigCard';
import { Calculator, Settings, Users, Shield } from "lucide-react";
import {EstimationRulesDialog} from './EstimationRulesDialog';
import {ValidationRulesDialog} from './ValidationRulesDialog';
import {ValidatorSetupDialog} from './ValidatorSetupDialog';
import {ExemptionCodesDialog} from './ExemptionCodesDialog';

export function ConfigSection() {
  const [openDialog, setOpenDialog] = useState<string | null>(null);
  
  const handleConfigClick = (configType: string) => {
    setOpenDialog(configType);
    // toast({
    //   title: `${configType} Configuration`,
    //   description: `Opening ${configType.toLowerCase()} configuration panel`,
    // });
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  return (
    <div className="mt-4 pb-8">
      <h2 className="page-subheading mb-4">Configuration</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {/* <ConfigCard
          icon={<Shield className="h-5 w-5" />}
          title="Validation Rules"
          description="Enable/disable validation logic."
          action="Configure"
          onClick={() => handleConfigClick("Validation")}
        />
        <ConfigCard
          icon={<Calculator className="h-5 w-5" />}
          title="Estimation Rules"
          description="Enable and disable estimation logics and set priority."
          action="Manage"
          onClick={() => handleConfigClick("Estimation")}
        /> */}
        <ConfigCard
          icon={<Users className="h-5 w-5" />}
          title="Validator Setup"
          description="Assign validators and supervisors per read cycle."
          action="Setup"
          onClick={() => handleConfigClick("Validator")}
        />
        <ConfigCard
          icon={<Settings className="h-5 w-5" />}
          title="Exemption Codes"
          description="Configure exemption codes and remarks options to add new codes, remarks."
          action="Manage"
          onClick={() => handleConfigClick("Exemption")}
        />
      </div>

      {/* Configuration Dialogs */}
      <ValidationRulesDialog 
        open={openDialog === "Validation"} 
        onClose={handleDialogClose} 
      />
      <EstimationRulesDialog 
        open={openDialog === "Estimation"} 
        onClose={handleDialogClose} 
      />
      <ValidatorSetupDialog 
        open={openDialog === "Validator"} 
        onClose={handleDialogClose} 
      />
      <ExemptionCodesDialog 
        open={openDialog === "Exemption"} 
        onClose={handleDialogClose} 
      />
    </div>
  );
}